import _ from 'underscore';
import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import $ from 'jquery';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Glyphicon, Button } from '@bingads-webui-react/primitive';
import { getFloatingHelpStyles } from '../styles/get-floating-help-styles';
import { FloatingGroup } from './floating-group';

const FloatingHelpUnStyled = ({
  classes,
  i18n,
  supportOptions,
  bottomPosition,
  uiActivity,
  isExpandedDefault,
  shouldSupportMobileView,
}) => {
  const [expanded, setExpanded] = useState(isExpandedDefault);
  const { IfShowLiveChat, RequestCallText } = supportOptions;

  const clickContactUs = () => {
    const currectExpandedState = !expanded;
    uiActivity.trace(`Floating help: ${currectExpandedState ? 'Expand' : 'Collapse'} contact us button`);
    setExpanded(currectExpandedState);
  };

  const clickChat = () => {
    uiActivity.trace('Floating help: Start a live chat');
    $('#msSupportChatTrigger').click();
  };

  const clickCall = () => {
    uiActivity.trace('Floating help: Request a call from support');
    $('#requestCallTrigger').click();
  };

  const items = [
    IfShowLiveChat && {
      id: 'floatingChat',
      className: 'floating-chat',
      renderItem: () => (
        <Fragment>
          <Button
            btnStyle="primary"
            className="floating-chat-button"
            onClick={clickChat}
          >
            <span
              className="floating-chat-glyph glyphicon"
            />
            <span className="floating-chat-text" >
              {i18n.getString(_TL_('Start a live chat'))}
            </span>
          </Button>
          <hr />
        </Fragment>
      ),
    },
    !_.isEmpty(RequestCallText) && {
      id: 'floatingCall',
      className: 'floating-call',
      renderItem: () => (
        <Button
          btnStyle="primary"
          className="floating-call-button"
          onClick={clickCall}
        >
          <span
            className="floating-call-glyph glyphicon"
          />
          <span className="floating-call-text" >
            {i18n.getString(_TL_('Request a call from support'))}
          </span>
        </Button>
      ),
    },
  ];

  const floatingHelpClassNames = ['floating-help', classes.floatingHelp, { [classes.mobileView]: shouldSupportMobileView, 'mobile-view': shouldSupportMobileView }];

  return (
    (IfShowLiveChat || !_.isEmpty(RequestCallText)) &&
    <div className={classNames(floatingHelpClassNames)} style={{ bottom: `${bottomPosition}` }}>
      <Button
        btnStyle="primary"
        onClick={clickContactUs}
        className="floating-help-contact-us-button"
        aria-expanded={expanded}
      >
        <Glyphicon
          glyph={expanded ? 'ba-ChevronDown' : 'ba-ChevronUp'}
          className="floating-contact-us-icon"
        />
        <span className="floating-contact-us-text">
          {i18n.getString(_TL_('Contact us'))}
        </span>
      </Button>
      {
        expanded &&
        <div className="floating-help-group">
          <FloatingGroup
            items={_.compact(items)}
            shouldSupportMobileView={shouldSupportMobileView}
          />
        </div>
      }
    </div>
  );
};

FloatingHelpUnStyled.propTypes = {
  classes: PropTypes.shape({
    floatingHelp: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  bottomPosition: PropTypes.string,
  uiActivity: PropTypes.shape({}).isRequired,
  supportOptions: PropTypes.shape({
    IfShowLiveChat: PropTypes.bool,
    RequestCallText: PropTypes.string,
  }).isRequired,
  isExpandedDefault: PropTypes.bool,
  shouldSupportMobileView: PropTypes.bool,
};

FloatingHelpUnStyled.defaultProps = {
  bottomPosition: '',
  isExpandedDefault: true,
  shouldSupportMobileView: false,
};

export const FloatingHelp = withDefaultStyles(FloatingHelpUnStyled, getFloatingHelpStyles);
